import CommonModal from "Pages/PhishingManager/components/Modal";
import { ModalProps } from "Pages/PhishingManager/components/Modal/Modal.types";


const ThreeMonthWhitelistingModal = ({ open, onClose, onConfirm }: ModalProps) => (<CommonModal
    visible={open}
    confirmText="View Whitelisting Guide"
    cancelText="Close"
    iconType={null}
    modalTitle="Reminder: Review Email Whitelisting"
    modalContentDesc={[
        "Email and security settings may affect delivery.",
        "To ensure phishing campaigns are delivered successfully, please review your email whitelist configuration."
    ]}
    onClose={onClose}
    onConfirm={onConfirm}
/>);

export default ThreeMonthWhitelistingModal;